<script lang="ts">
  import { giftsConfig } from "../config/gifts";
  import { mobileActivityIndex, assetsProgress } from "../store/AppState";
  import MobileGift from "../MobileGift.svelte";

  export let onLoad: () => void;

  $: loadedCounter = 0;

  const handleLoad = () => {
    loadedCounter++;
    $assetsProgress += 1;
    if (loadedCounter >= 2) {
      onLoad();
    }
  };

  $: currentGifts = giftsConfig.slice(
    $mobileActivityIndex - 2,
    $mobileActivityIndex + 1
  );
  $: if ($mobileActivityIndex === 24) {
    currentGifts = [giftsConfig[22], giftsConfig[23], giftsConfig[0]];
  }
  $: if ($mobileActivityIndex === 1) {
    currentGifts = [giftsConfig[23], giftsConfig[0], giftsConfig[1]];
  }
</script>

{#key $mobileActivityIndex}
  <div class="gifts-container">
    {#each currentGifts as item, index}
      <MobileGift config={item} {index} onLoad={handleLoad} />
    {/each}
  </div>
  <img
    class="zar"
    src={`${__PUBLIC_PATH__}images/darky_zare.svg`}
    alt="Darkozar"
  />
{/key}

<style>
  .gifts-container {
    display: flex;
    overflow: hidden;
    justify-content: space-around;
    align-items: flex-end;
    pointer-events: none;
  }

  .zar {
    height: 120vh;
    bottom: -2px; /* Some strange visual thing? */
    padding: 0;
    margin: 0;
    width: 100%;
    object-fit: cover;
    z-index: 1;
    position: absolute;
    pointer-events: none;
  }
</style>
